const Coursework = [
    {
        'code': '[1st Year]',
        'title': '76.79 %',
        'grade': '8.37(CGPA)'
    },
    {
        'code': '[2nd Year]',
        'title': '56.94 %',
        'grade': '7.23(CGPA)'
    },
    {
        'code': '[3rd Year]',
        'title': '73 %',
        'grade': 'PASS'
    },
    {
        'code': '[10TH SSC]',
        'title': '80 %',
        'grade': 'PASS'
    },
    {
        'code': '[12TH  HSC]',
        'title': '70 %',
        'grade': 'PASS'
    },
//     {
//         'code': '[CSE 127]',
//         'title': 'Computer Security',
//         'grade': 'N/A'
//     },
//     {
//         'code': '[CSE 123]',
//         'title': 'Computer Networks',
//         'grade': 'N/A'
//     },
//     {
//         'code': '[CSE 120]',
//         'title': 'Operating Systems',
//         'grade': 'B'
//     },
//     {
//         'code': '[CSE 110]',
//         'title': 'Software Engineering',
//         'grade': 'A'
//     },
//     {
//         'code': '[CSE 101]',
//         'title': 'Advanced Algorithms',
//         'grade': 'B'
//     },
//     {
//         'code': '[CSE 105]',
//         'title': 'Theory of Computation',
//         'grade': 'A-'
//     },
//     {
//         'code': '[CSE 100]',
//         'title': 'Advanced Data Structures',
//         'grade': 'A+'
//     },
//     {
//         'code': '[CSE 30]',
//         'title': 'Systems Programming',
//         'grade': 'A+'
//     }
];

export default Coursework;
